export default __webpack_public_path__ + "assets/ce898c455b861c765437da60d30f6c97.jpg";